<div class="company-group-autocomplete-host">
    <mat-form-field
        #companyGroupFormField
        class="company-group-autocomplete-form-field no-padding-margin-mat-form-field"
        [attr.data-cy]="'ccgacga_mat-form-field_1_8_'"
    >
        <input
            #companyGroupInput="matInput"
            #companyGroupTrigger="matAutocompleteTrigger"
            matInput
            [matAutocomplete]="autoCompanyGroup"
            [formControl]="companyGroupCtrl"
            placeholder="Unternehmensgruppe"
            [attr.data-cy]="'ccgacga_input_1_1_'"
        />
        <mat-autocomplete
            #autoCompanyGroup="matAutocomplete"
            [displayWith]="companyGroupMapper"
            (optionSelected)="companyGroupSelected($event)"
            (opened)="onAutocompleteOpened()"
            [panelWidth]="panelWidthPx"
            panelClass="company-group-autocomplete-panel"
        >
            <ng-container *ngFor="let cg of companyGroups | async; let i = index">
                <mat-option
                    *ngIf="cg?.bezeichnung"
                    [value]="cg"
                    [attr.data-cy]="'ccgacga_mat-option_1_7_' + i"
                >
                    {{ cg.bezeichnung }}
                </mat-option>
            </ng-container>
        </mat-autocomplete>
    </mat-form-field>
</div>
